import type { OptionsDocument } from 'paintscout'
import { getObjectLabels } from '../../builder/util/get-object-labels'

export function getTemplateTags(args: {
  options: OptionsDocument
  invoice?: boolean
  event?: boolean
  leadForm?: boolean
}) {
  const { options, invoice, event, leadForm } = args
  const { quote } = getObjectLabels({ options, invoice })

  if (leadForm) {
    return [
      {
        key: 'companyName',
        label: 'Company Name',
        hideValue: true
      },
      {
        key: 'companyPhone',
        label: 'Company Phone',
        hideValue: true
      },
      {
        key: 'companyAddress',
        label: 'Company Address',
        hideValue: true
      }
    ]
  }

  return [
    {
      key: 'companyName',
      label: 'Company Name',
      hideValue: true
    },
    {
      key: 'clientName',
      label: 'Client Name',
      hideValue: true
    },
    {
      key: 'clientFirstName',
      label: 'Client First Name',
      hideValue: true
    },
    {
      key: 'clientLastName',
      label: 'Client Last Name',
      hideValue: true
    },
    ...(event
      ? [
          {
            key: 'eventType',
            label: 'Event Type',
            hideValue: true
          },
          {
            key: 'eventDate',
            label: 'Event Date',
            hideValue: true
          },
          {
            key: 'eventTime',
            label: 'Event Time',
            hideValue: true
          },
          {
            key: 'eventAssigneeFullName',
            label: 'Event Assignee Full Name',
            hideValue: true
          },
          {
            key: 'eventAssigneeFirstName',
            label: 'Event Assignee First Name',
            hideValue: true
          },
          {
            key: 'eventAssigneeEmail',
            label: 'Event Assignee Email',
            hideValue: true
          },
          {
            key: 'eventAssigneePhone',
            label: 'Event Assignee Phone',
            hideValue: true
          },
          {
            key: 'eventLocation',
            label: 'Event Location',
            hideValue: true
          },
          {
            key: 'eventDescription',
            label: 'Event Description',
            hideValue: true
          }
        ]
      : [
          {
            key: 'clientSecondaryFirstName',
            label: 'Client Secondary First Name',
            hideValue: true
          },
          {
            key: 'clientSecondaryLastName',
            label: 'Client Secondary Last Name',
            hideValue: true
          },
          { key: 'address', label: 'Client/Job Address', hideValue: true },
          { key: 'city', label: 'Client/Job City', hideValue: true },
          { key: 'state', label: 'Client/Job State', hideValue: true },
          { key: 'zip', label: 'Client/Job Zip Code', hideValue: true },
          { key: 'jobIdentifier', label: 'Job Identifier', hideValue: true },
          {
            key: 'quoteDate',
            label: `${quote.value} Date`,
            hideValue: true
          },
          {
            key: 'quoteNumber',
            label: `${quote.value} Number`,
            hideValue: true
          },
          {
            key: 'intExt',
            label: `${quote.value} Type`,
            hideValue: true
          },
          {
            key: 'estimatorInfo',
            label: `Estimator Info`,
            hideValue: true
          }
        ]),
    {
      key: 'estimatorName',
      label: `Estimator Name`,
      hideValue: true
    },
    {
      key: 'estimatorFirstName',
      label: `Estimator First Name`,
      hideValue: true
    },
    {
      key: 'estimatorEmail',
      label: `Estimator Email`,
      hideValue: true
    },
    {
      key: 'estimatorPhone',
      label: `Estimator Phone`,
      hideValue: true
    }
  ]
}

export function getTemplateContext(editorPreference?: string) {
  return {
    companyName: '{{companyName}}',
    companyPhone: '{{companyPhone}}',
    companyAddress: '{{companyAddress}}',
    clientName: '{{clientName}}',
    clientFirstName: '{{clientFirstName}}',
    clientLastName: '{{clientLastName}}',
    clientSecondaryFirstName: '{{clientSecondaryFirstName}}',
    clientSecondaryLastName: '{{clientSecondaryLastName}}',
    address: '{{address}}',
    city: '{{city}}',
    state: '{{state}}',
    zip: '{{zip}}',
    jobIdentifier: '{{jobIdentifier}}',
    quoteDate: '{{quoteDate}}',
    quoteNumber: '{{quoteNumber}}',
    fileType: '{{fileType}}',
    intExt: '{{quoteType}}',
    estimatorInfo:
      editorPreference !== 'always'
        ? '{{estimatorName}}<br/>{{estimatorEmail}}<br/>{{estimatorPhone}}'
        : '{{estimatorName}}\n{{estimatorEmail}}\n{{estimatorPhone}}',
    estimatorName: '{{estimatorName}}',
    estimatorFirstName: '{{estimatorFirstName}}',
    estimatorEmail: '{{estimatorEmail}}',
    estimatorPhone: '{{estimatorPhone}}',
    eventType: '{{eventType}}',
    eventDate: '{{eventDate}}',
    eventTime: '{{eventTime}}',
    eventAssigneeFullName: '{{eventAssigneeFullName}}',
    eventAssigneeFirstName: '{{eventAssigneeFirstName}}',
    eventAssigneeEmail: '{{eventAssigneeEmail}}',
    eventAssigneePhone: '{{eventAssigneePhone}}',
    eventLocation: '{{eventLocation}}',
    eventDescription: '{{eventDescription}}',
    eventRescheduledDate: '{{eventRescheduledDate}}',
    eventRescheduledTime: '{{eventRescheduledTime}}'
  }
}
